import { render, staticRenderFns } from "./AddArea.vue?vue&type=template&id=77654774&"
import script from "./AddArea.vue?vue&type=script&lang=js&"
export * from "./AddArea.vue?vue&type=script&lang=js&"
import style0 from "./AddArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddArea.vue"
export default component.exports